import { Controller } from "@hotwired/stimulus"
import QRCode from 'qrcode'

export default class extends Controller {
  static targets = ["display"]
  static outlets = ["pos--keypad"]

  connect() {
    console.log("QR Controller Connected")
    this.generateQR()
  }

  async generateQR() {
    const permitData = {
      type: 'permit',
      amount: '50',
      token: 'USDC',
      deadline: Math.floor(Date.now() / 1000) + 3600
    }

    const contractAddress = '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913'
    const chainId = 8453
    const eip681Url = `ethereum:${contractAddress}@${chainId}/permit?` + 
      `uint256=${permitData.amount}&` +
      `uint256=${permitData.deadline}&` +
      `data=${encodeURIComponent(JSON.stringify(permitData))}`

    console.log("Permit Data:", permitData)
    console.log("EIP-681 URL:", eip681Url)
    
    try {
      await QRCode.toCanvas(this.displayTarget, eip681Url, {
        width: 300,
        margin: 2,
        color: {
          dark: '#FFFFFF',
          light: '#000000'
        }
      })
      console.log("QR Code Generated Successfully")
    } catch (error) {
      console.error("QR Generation Error:", error)
    }
  }
}